module.exports = __webpack_public_path__ + "img/tmpBanner.453ff686.svg";